import { render, staticRenderFns } from "./FilePlayer.vue?vue&type=template&id=7c36c164&"
import script from "./FilePlayer.vue?vue&type=script&lang=ts&"
export * from "./FilePlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports